var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 23,
    fill: "black",
    fillOpacity: 0.02
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2969 17.5586L18.2226 29.9011C18.2479 30.2387 18.5292 30.4998 18.8678 30.4998H27.0642C27.3967 30.4998 27.675 30.2479 27.7081 29.9171L28.9439 17.5586",
    stroke: "#040404",
    strokeWidth: 0.647059,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 15.6176H20.8529M30.2353 15.6176H25.5441M20.8529 15.6176L21.9528 14.2428C22.0756 14.0894 22.2615 14 22.4581 14H24.0749C24.286 14 24.4839 14.103 24.605 14.276L25.5441 15.6176M20.8529 15.6176H25.5441",
    stroke: "#040404",
    strokeWidth: 0.647059,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8828 18.5293L20.5299 28.5587",
    stroke: "#040404",
    strokeWidth: 0.647059,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7031 28.5587L26.3502 18.5293",
    stroke: "#040404",
    strokeWidth: 0.647059,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1172 18.5293V28.5587",
    stroke: "#040404",
    strokeWidth: 0.647059,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.346e762cb92bb640339a343b60a854ec.svg";
export { ForwardRef as ReactComponent };